const textEncoder = new TextEncoder();

function hasSecureRandomSource(): boolean {
    return typeof globalThis.crypto?.getRandomValues === 'function';
}

export function safeStringEquals(left?: string | null, right?: string | null): boolean {
    if (typeof left !== 'string' || typeof right !== 'string') {
        return left === right;
    }

    const leftBytes = textEncoder.encode(left);
    const rightBytes = textEncoder.encode(right);

    if (leftBytes.length !== rightBytes.length) {
        return false;
    }

    let result = 0;
    for (let index = 0; index < leftBytes.length; index += 1) {
        result |= leftBytes[index] ^ rightBytes[index];
    }

    return result === 0;
}

export function getSecureRandomNumber(maximum = 1): number {
    if (maximum <= 0) {
        return 0;
    }

    if (hasSecureRandomSource()) {
        const buffer = new Uint32Array(1);
        globalThis.crypto.getRandomValues(buffer);
        return (buffer[0] / 0x100000000) * maximum;
    }

    return 0;
}

export function shouldShowWithSecureChance(chance: number): boolean {
    if (chance <= 0) {
        return false;
    }

    if (chance >= 1) {
        return true;
    }

    if (!hasSecureRandomSource()) {
        return false;
    }

    return getSecureRandomNumber(1) < chance;
}

export function buildSafeRedirectUrl(baseAppUrl: string | undefined, currentHref: string): string | null {
    if (!baseAppUrl) {
        return null;
    }

    try {
        const currentUrl = new URL(currentHref);
        const baseUrl = new URL(baseAppUrl, currentUrl.origin);

        if (currentUrl.origin === baseUrl.origin || currentUrl.hostname === 'localhost') {
            return null;
        }

        const safeTarget = new URL(currentUrl.pathname + currentUrl.search + currentUrl.hash, baseUrl);
        if (safeTarget.origin !== baseUrl.origin || !['http:', 'https:'].includes(safeTarget.protocol)) {
            return null;
        }

        return safeTarget.toString();
    } catch (error) {
        return null;
    }
}
